import { valueOf } from "@/types/common";

export const NOTIFICATION_TAB = {
  ALL: "1",
  // IMPORTANT: "important",
  SYSTEM: "system",
  IROHANA: "irohana",
} as const;

export type TNotificationTab = valueOf<typeof NOTIFICATION_TAB>;

export const isNotificationTab = (value: string): value is TNotificationTab =>
  (Object.values(NOTIFICATION_TAB) as string[]).includes(value);

export const NOTIFICATION_TAB_LABEL = {
  [NOTIFICATION_TAB.ALL]: "すべて",
  // [NOTIFICATION_TAB.IMPORTANT]: "重要なお知らせ",
  [NOTIFICATION_TAB.SYSTEM]: "制度・手続き",
  [NOTIFICATION_TAB.IROHANA]: "irohana",
};

export const NOTIFICATION_TYPE = {
  IMPORTANT: "important",
  SYSTEM: "system",
  IROHANA: "irohana",
};

export type TNotificationType = valueOf<typeof NOTIFICATION_TYPE>;

export const NOTIFICATION_TYPE_LABEL = {
  [NOTIFICATION_TYPE.IMPORTANT]: "重要なお知らせ",
  [NOTIFICATION_TYPE.SYSTEM]: "制度・手続き",
  [NOTIFICATION_TYPE.IROHANA]: "irohana",
};
